import service from "./service"

const submitPreCheckConsentAndStartSession = async (data) => {
    return service(data)
}

export default submitPreCheckConsentAndStartSession
